define('frontend-common-components/objectStorageConfig/js/mixins/marionette/handleErrorDisplay',[
], function () {
    'use strict';
    return {

        showInfo: function (errorMessageArea, message) {
            errorMessageArea.removeClass('text-error');
            errorMessageArea.text(message);
        },

        showError: function (errorMessageArea, message) {
            errorMessageArea.addClass('text-error');
            errorMessageArea.text(message);
        },

        markErrorField: function (field) {
            field.addClass('has-error');
        },

        clearErrorField: function (field) {
            field.removeClass('has-error');
        }

    };
});

